// extracted by mini-css-extract-plugin
module.exports = {"container":"_2i7qbpN9"};